import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    padding: "20px 14px",
  },
  right: {
    width: "100%",
    whiteSpace: "pre-wrap",
  },
  left: {
    width: 40,
    transform: "translateY(2px)",
  },
  success: {
    color: `${theme.colors.defaultTextColor} !important`,
  },
  failure: {
    color: `${theme.colors.warning} !important`,
  },
}));

export default useStyles;
